/* global  moment, _ */
import './style.less';

export default function($log, $state, ApiClass, Swal, UserClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.isAdmin = $state.$current.includes && $state.$current.includes['app.admin'];

  vm.revoke = event => {
    const { profile_uid, email } = event.registration;
    event.revokeBtn = true;

    return Swal.confirm('Revoke Registration?', `Revoke ${email || 'user'} registration for this event.`)
      .then(() =>
        ApiClass.eventsIdTypeTypeIdDelete(
          { id: event.event_id, type: 'attendees', type_id: profile_uid },
          {},
          { queryParams: { manage: UserClass.isAdmin } }
        )
      )
      .then(() => {
        $state.reload();
        Swal.toast('Revoked registration');
        event.revokeBtn = false;
      })
      .catch(error => {
        event.revokeBtn = false;
        if (error.dismiss) return;
        Swal.toast('Error revoking registration', 'error');
        $log.error(error);
        throw error;
      });
  };

  vm.eventHeaders = [
    { title: 'Date', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2', sort: 'sortTime' },
    { title: 'Name', class: 'col-lg-4 col-md-4 col-sm-4 col-xs-4', sort: 'course_name' },
    { title: 'Credits', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' },
    { title: 'Status', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2', sort: 'status' },
    { title: '', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' }
  ];

  function activate() {
    $log.debug('Event Basic Table Component Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tables/eventsBasic/controller.js